import { Injectable } from '@angular/core';
import {
  DateAdapter,
  NativeDateAdapter,
  provideNativeDateAdapter,
} from '@angular/material/core';

// Date.parse can't read the Swiss d.m.yyyy (or d/m/yyyy) a user types.
@Injectable()
export class SwissDateAdapter extends NativeDateAdapter {
  override parse(value: unknown, parseFormat?: unknown): Date | null {
    const match =
      typeof value === 'string' &&
      /^\s*(\d{1,2})[./-](\d{1,2})[./-](\d{4})\s*$/.exec(value);
    if (!match) return super.parse(value, parseFormat);
    const [day, month, year] = match.slice(1).map(Number);
    const date = new Date(year, month - 1, day);
    return date.getDate() === day && date.getMonth() === month - 1
      ? date
      : this.invalid();
  }
}

// provideNativeDateAdapter also brings MAT_DATE_FORMATS
export const provideSwissDateAdapter = () => [
  provideNativeDateAdapter(),
  { provide: DateAdapter, useClass: SwissDateAdapter },
];
